import React, { Component } from 'react';
import { connect } from 'react-redux';

// Demo: Testing version detection for uncommitted changes
import Aux from '../../hoc/Auxiliary/Auxiliary';
import ufcLogo from '../../assets/images/ufc-logo-mini-faded.png';
import Input from '../../components/UI/Input/Input';
import Button from '../../components/UI/Button/Button';
import Spinner from '../../components/UI/Spinner/Spinner';
import UserPreferencesModal from '../../components/UserPreferencesModal/UserPreferencesModal';
import classes from './Account.css';
import logError from '../../store/LogError';
import axios from '../../axios-trips';
import * as actionTypes from '../../store/actions';
import qs from 'qs';

class Account extends Component {

  createInputConfig = (elementType,
    elementConfig,
    label,
    value = '',
    validation = {},
    valid = true,
    extraAction = null) => {
    return ({
      elementType: elementType,
      elementConfig: elementConfig,
      label: label,
      value: value,
      validation: validation,
      valid: valid,
      touched: false,
      errorMessage: null,
      extraAction: extraAction
    });
  }

  transformLocations() {
    let transformedLocations = [];
    Object.keys(this.props.locations).forEach(key => {
      transformedLocations.push({
        id: this.props.locations[key].id,
        location: key,
        region: this.props.locations[key].region,
        originatingLocation: this.props.locations[key].originatingLocation
      })
    });
    return transformedLocations;
  }

  state = {
    loading: false,
    registered: true,
    forgotPassword: false,
    resetPassword: false,
    telegramChats: [],
    editManagerPreferences: null,
    registerForm: {
      fname: this.createInputConfig(
        'input',
        { type: 'text' },
        'Ім\'я: '),
      lname: this.createInputConfig(
        'input',
        { type: 'text' },
        'Прізвище: '),
      email: this.createInputConfig(
        'email',
        { type: 'text' },
        'UFC Пошта* (введіть без @ufc.dp.ua): ',
        '',
        { required: true, type: 'email' }),
      password: this.createInputConfig(
        'input',
        { type: 'password' },
        'Пароль*: ',
        '',
        { required: true, minLength: 5, type: 'password' },
        false),
      confirmPassword: this.createInputConfig(
        'input',
        { type: 'password' },
        'Підтвердіть Пароль*: ',
        '',
        { required: true, minLength: 5, type: 'confirmPassword' },
        false),
    },
    loginForm: {
      email: this.createInputConfig(
        'email',
        { type: 'text' },
        'Пошта: ',
        '',
        { required: true, type: 'email' }),
      password: this.createInputConfig(
        'input',
        { type: 'password' },
        'Пароль: ',
        '',
        { required: true, type: 'password' },
        false)
    },
    forgotPasswordForm: {
      email: this.createInputConfig(
        'email',
        { type: 'text' },
        'Пошта: ',
        '',
        { required: true, type: 'email' }),
    },
    resetPasswordForm: {
      password: this.createInputConfig(
        'input',
        { type: 'password', },
        'Пароль: ',
        '',
        { required: true, type: 'password' }),
      passwordConfirm: this.createInputConfig(
        'input',
        { type: 'password' },
        'Підтвердіть Пароль*: ',
        '',
        { required: true, minLength: 5, type: 'confirmPassword' },
        false)
    },
    locationForm: {
      locations: this.createInputConfig(
        'locations',
        {},
        'Локації:',
        this.transformLocations(),
        { type: 'locations' },
        false
      )
    },
    usersForm: {
      users: this.createInputConfig(
        'users',
        {},
        'Користувачі:',
        [],
        { type: 'users' },
        false
      )
    },
    managersForm: {
      managers: this.createInputConfig(
        'managersEdit',
        { options: [], usernames: [] },
        'Менеджери:',
        [],
        {},
        false,
        { editManagerPreferences: (ev, index) => this.editManagerPreferences(ev, index) })
    },
    initialUserRoles: [],
    formIsValid: false,
    resetPasswordToken: null
  }

  editManagerPreferences(ev, index) {
    ev.preventDefault();
    this.setState({ editManagerPreferences: this.state.managersForm.managers.value[index].name })
  }

  compareName = (a, b) => {
    if (a.name > b.name) {
      return 1;
    } else if (a.name < b.name) {
      return -1;
    }
    return 0;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.locations !== this.props.locations) {
      const updatedLocationForm = { ...this.state.locationForm };
      updatedLocationForm.locations.value = this.transformLocations();

      this.setState({ locationForm: updatedLocationForm });
    }

    if (prevProps.managers !== this.props.managers || !prevProps.authenticated && this.props.authenticated) {
      if (this.props.managers.length <= 2) {
        this.createManagers();
      }
      const updatedManagerForm = { ...this.state.managersForm };
      updatedManagerForm.managers.value = [...this.props.managers].sort(this.compareName);
      this.setState({ managersForm: updatedManagerForm });
    }

    if (!prevProps.authenticated && this.props.authenticated) {
      this.getUsers();
      this.getTelegramChats();
    }

    if (prevState.telegramChats !== this.state.telegramChats) {
      const updatedManagerForm = { ...this.state.managersForm };
      updatedManagerForm.managers.elementConfig.options = [...this.state.telegramChats];
      this.setState({ managersForm: updatedManagerForm });
    }
  }

  componentDidMount() {
    const query = new URLSearchParams(window.location.search);
    if (query.get("token")) {
      let confirmToken = query.get("token");
      this.setState({ loading: true });
      axios.get('/api/v1/signup/confirm?token=' + confirmToken)
        .then(response => {
          console.log(response);
          this.props.addNotification("Вітаємо, ви підтвердили свій акаунт. Тепер ви можете використовувати свою пошту та пароль, щоб увійти.", "Success");
          this.setState({ loading: false });
        })
        .catch(error => {
          console.log(error);
          this.setState({ loading: false });
          if (error.response) {
            logError(
              this.props.access_token,
              this.props.codeToMessage[error.response.status],
              '/api/v1/signup/confirm?token=' + confirmToken
            );
            this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
          }
        });
    } else if (query.get("resetToken")) {
      this.setState({
        resetPasswordToken: query.get("resetToken"),
        resetPassword: true
      });
    } else if (this.props.authenticated) {
      if (this.props.managers.length <= 2) {
        this.createManagers();
      }
      this.getUsers();
      this.getTelegramChats();
    }

    const updatedLocationForm = { ...this.state.locationForm };
    updatedLocationForm.locations.value = this.transformLocations();

    const updatedManagerForm = { ...this.state.managersForm };
    updatedManagerForm.managers.value = [...this.props.managers].sort(this.compareName);
    this.setState({ managersForm: updatedManagerForm });

    this.setState({ locationForm: updatedLocationForm });
  }

  createManagers() {
    axios({
      method: 'get',
      url: '/api/v1/managers',
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        const cardForm = { ...this.state.requestForm };
        this.props.onSetManagers(response.data);
      })
      .catch(error => {
        console.log(error.response);
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/managers'
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        }
      });
  }

  checkValidity(value, rules, password = '') {
    let isValid = true;

    if (rules.required) {
      isValid = value.trim !== '' && isValid;
    }

    if (rules.type == 'confirmPassword') {
      isValid = password === value && isValid;
    }

    if (rules.minLength) {
      isValid = value.length >= rules.minLength && isValid;
    }

    if (rules.maxLength) {
      isValid = value.length <= rules.maxLength && isValid;
    }

    return isValid;
  }

  getErrorMessage(value, rules, password = '') {
    let errorMessage = '';

    if (rules.required && value.trim === '') {
      errorMessage = 'Це поле обов\'язкове';
    }

    if (rules.type == 'confirmPassword' && password !== value) {
      errorMessage = 'Паролі повинні співпадати';
    }

    if (rules.minLength && value.length < rules.minLength) {
      errorMessage = 'Мінімальна довжина: ' + rules.minLength;
    }

    if (rules.maxLength && value.length > rules.maxLength) {
      errorMessage = 'Максимальна довжина: ' + rules.minLength;
    }

    return errorMessage;
  }

  compareEmails = (a, b) => {
    if (a.email > b.email) {
      return 1;
    } else if (a.email < b.email) {
      return -1;
    }
    return 0;
  }

  getUsers() {
    axios({
      method: 'get',
      url: '/api/v1/users/roles',
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        const updatedUserForm = { ...this.state.usersForm };
        const users = [];
        const usernames = ["-"];
        for (let i = 0; i < response.data.length; i++) {
          users.push({
            email: response.data[i].email,
            role: response.data[i].roleId,
            locked: response.data[i].locked,
            asteriskId: response.data[i].asteriskId,
            miniAsterisk: response.data[i].miniAsterisk
          });
          usernames.push(response.data[i].email);
        }

        updatedUserForm.users.value = users.sort(this.compareEmails);

        const deepCopy = [];
        for (let i = 0; i < users.length; i++) {
          deepCopy.push({ ...users[i] });
        }

        const updatedManagerForm = { ...this.state.managersForm };
        updatedManagerForm.managers.elementConfig.usernames = usernames;
        this.setState({
          loading: false,
          usersForm: updatedUserForm,
          initialUserRoles: deepCopy,
          managersForm: updatedManagerForm
        });
      })
      .catch(error => {
        console.log(error.response);
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/users/roles'
          );
        }
      });
  }

  getTelegramChats() {
    axios({
      method: 'get',
      url: '/api/v1/telegram/chats',
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        this.setState({ telegramChats: [{ value: "", displayValue: "" }, ...response.data.map(chat => ({ value: chat.chatId, displayValue: chat.title + " (" + chat.chatId + ")" }))] });
      })
      .catch(error => {
        console.log(error.response);
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/telegram/chats'
          );
        }
      });
  }

  inputChangedHandler = (event, elementId) => {
    const updatedOrderForm = {
      ...this.state.registerForm
    }
    const updatedFormElement = {
      ...updatedOrderForm[elementId]
    }

    updatedFormElement.value = event.target.value;
    updatedFormElement.touched = true;
    if (elementId === 'confirmPassword') {
      updatedFormElement.valid = this.checkValidity(updatedFormElement.value,
        updatedFormElement.validation,
        updatedOrderForm.password.value);
      updatedFormElement.errorMessage = this.getErrorMessage(updatedFormElement.value,
        updatedFormElement.validation,
        updatedOrderForm.password.value);
      updatedOrderForm.confirmPassword.valid = this.checkValidity(updatedOrderForm.password.value,
        updatedOrderForm.password.validation,
        updatedOrderForm.password.value);
      updatedFormElement.errorMessage = this.getErrorMessage(updatedOrderForm.password.value,
        updatedOrderForm.password.validation,
        updatedOrderForm.password.value);
    } else if (elementId === 'password') {
      updatedFormElement.valid = this.checkValidity(updatedFormElement.value,
        updatedFormElement.validation,
        updatedOrderForm.password.value);
      updatedFormElement.errorMessage = this.getErrorMessage(updatedFormElement.value,
        updatedFormElement.validation,
        updatedOrderForm.password.value);
      updatedOrderForm.confirmPassword.valid = this.checkValidity(updatedOrderForm.confirmPassword.value,
        updatedOrderForm.confirmPassword.validation,
        updatedOrderForm.password.value);
      updatedFormElement.errorMessage = this.getErrorMessage(updatedOrderForm.confirmPassword.value,
        updatedOrderForm.confirmPassword.validation,
        updatedOrderForm.password.value);
    } else if (updatedFormElement.validation.type === 'email') {
      let indexAt = updatedFormElement.value.indexOf('@');
      if (indexAt !== -1) {
        updatedFormElement.value = updatedFormElement.value.substring(0, indexAt);
      }
      updatedFormElement.valid = this.checkValidity(updatedFormElement.value,
        updatedFormElement.validation);
      updatedFormElement.errorMessage = this.getErrorMessage(updatedFormElement.value,
        updatedFormElement.validation);
    } else {
      updatedFormElement.valid = this.checkValidity(updatedFormElement.value,
        updatedFormElement.validation);
      updatedFormElement.errorMessage = this.getErrorMessage(updatedFormElement.value,
        updatedFormElement.validation);
    }

    updatedOrderForm[elementId] = updatedFormElement;

    let formIsValid = true;
    for (let inputIdentifier in updatedOrderForm) {
      formIsValid = updatedOrderForm[inputIdentifier].valid && formIsValid;
    }

    this.setState({ registerForm: updatedOrderForm, formIsValid: formIsValid });
  }

  loginInputChangedHandler = (event, elementId) => {
    const updatedOrderForm = {
      ...this.state.loginForm
    }
    const updatedFormElement = {
      ...updatedOrderForm[elementId]
    }

    updatedFormElement.value = event.target.value;
    updatedFormElement.touched = true;
    if (updatedFormElement.validation.type === 'email') {
      let indexAt = updatedFormElement.value.indexOf('@');
      if (indexAt !== -1) {
        updatedFormElement.value = updatedFormElement.value.substring(0, indexAt);
      }
      updatedFormElement.valid = this.checkValidity(updatedFormElement.value,
        updatedFormElement.validation,
        updatedOrderForm.password.value);
      updatedFormElement.errorMessage = this.getErrorMessage(updatedFormElement.value,
        updatedFormElement.validation,
        updatedOrderForm.password.value);
    } else {
      updatedFormElement.valid = this.checkValidity(updatedFormElement.value,
        updatedFormElement.validation);
      updatedFormElement.errorMessage = this.getErrorMessage(updatedFormElement.value,
        updatedFormElement.validation);
    }
    updatedOrderForm[elementId] = updatedFormElement;

    let formIsValid = true;
    for (let inputIdentifier in updatedOrderForm) {
      formIsValid = updatedOrderForm[inputIdentifier].valid && formIsValid;
    }

    this.setState({ loginForm: updatedOrderForm, formIsValid: formIsValid });
  }

  forgotPasswordInputChangedHandler = (event, elementId) => {
    const updatedOrderForm = {
      ...this.state.forgotPasswordForm
    }
    const updatedFormElement = {
      ...updatedOrderForm[elementId]
    }

    updatedFormElement.value = event.target.value;
    updatedFormElement.touched = true;

    if (updatedFormElement.validation.type === 'email') {
      let indexAt = updatedFormElement.value.indexOf('@');
      if (indexAt !== -1) {
        updatedFormElement.value = updatedFormElement.value.substring(0, indexAt);
      }
      updatedFormElement.valid = this.checkValidity(updatedFormElement.value,
        updatedFormElement.validation,
        "");
      updatedFormElement.errorMessage = this.getErrorMessage(updatedFormElement.value,
        updatedFormElement.validation,
        "");
    } else {
      updatedFormElement.valid = this.checkValidity(updatedFormElement.value,
        updatedFormElement.validation);
      updatedFormElement.errorMessage = this.getErrorMessage(updatedFormElement.value,
        updatedFormElement.validation);
    }
    updatedOrderForm[elementId] = updatedFormElement;

    let formIsValid = true;
    for (let inputIdentifier in updatedOrderForm) {
      formIsValid = updatedOrderForm[inputIdentifier].valid && formIsValid;
    }

    this.setState({ forgotPasswordForm: updatedOrderForm, formIsValid: formIsValid });
  }

  resetPasswordInputChangedHandler = (event, elementId) => {
    const updatedOrderForm = {
      ...this.state.resetPasswordForm
    }
    const updatedFormElement = {
      ...updatedOrderForm[elementId]
    }

    updatedFormElement.value = event.target.value;
    updatedFormElement.touched = true;
    if (updatedOrderForm[elementId].validation.type === 'confirmPassword') {
      updatedFormElement.valid = this.checkValidity(updatedFormElement.value,
        updatedFormElement.validation,
        updatedOrderForm.password.value);
      updatedFormElement.errorMessage = this.getErrorMessage(updatedFormElement.value,
        updatedFormElement.validation,
        updatedOrderForm.password.value);
    } else if (updatedFormElement.validation.type === 'email') {
      let indexAt = updatedFormElement.value.indexOf('@');
      if (indexAt !== -1) {
        updatedFormElement.value = updatedFormElement.value.substring(0, indexAt);
      }
      updatedFormElement.valid = this.checkValidity(updatedFormElement.value,
        updatedFormElement.validation,
        updatedOrderForm.password.value);
      updatedFormElement.errorMessage = this.getErrorMessage(updatedFormElement.value,
        updatedFormElement.validation,
        updatedOrderForm.password.value);
    } else {
      updatedFormElement.valid = this.checkValidity(updatedFormElement.value,
        updatedFormElement.validation);
      updatedFormElement.errorMessage = this.getErrorMessage(updatedFormElement.value,
        updatedFormElement.validation);
    }
    updatedOrderForm[elementId] = updatedFormElement;

    let formIsValid = true;
    for (let inputIdentifier in updatedOrderForm) {
      formIsValid = updatedOrderForm[inputIdentifier].valid && formIsValid;
    }

    this.setState({ resetPasswordForm: updatedOrderForm, formIsValid: formIsValid });
  }

  locationChangedHandler = (event, elementId) => {
    const updatedOrderForm = {
      ...this.state.locationForm
    }
    const updatedFormElement = {
      ...updatedOrderForm[elementId]
    }

    updatedFormElement.value = event.target.value;
    updatedFormElement.touched = true;
    updatedFormElement.valid = this.checkValidity(updatedFormElement.value,
      updatedFormElement.validation);
    updatedFormElement.errorMessage = this.getErrorMessage(updatedFormElement.value,
      updatedFormElement.validation);

    updatedOrderForm[elementId] = updatedFormElement;

    let formIsValid = true;
    for (let inputIdentifier in updatedOrderForm) {
      formIsValid = updatedOrderForm[inputIdentifier].valid && formIsValid;
    }

    this.setState({ locationForm: updatedOrderForm, formIsValid: formIsValid });
  }

  usersChangedHandler = (event, elementId) => {
    const updatedOrderForm = {
      ...this.state.usersForm
    }
    const updatedFormElement = {
      ...updatedOrderForm[elementId]
    }

    updatedFormElement.value = event.target.value;
    updatedFormElement.touched = true;
    updatedFormElement.valid = this.checkValidity(updatedFormElement.value,
      updatedFormElement.validation);
    updatedFormElement.errorMessage = this.getErrorMessage(updatedFormElement.value,
      updatedFormElement.validation);

    updatedOrderForm[elementId] = updatedFormElement;

    this.setState({ usersForm: updatedOrderForm });
  }

  managersChangedHandler = (event, elementId) => {
    const updatedOrderForm = {
      ...this.state.managersForm
    }
    const updatedFormElement = {
      ...updatedOrderForm[elementId]
    }

    updatedFormElement.value = event.target.value;
    updatedFormElement.touched = true;
    updatedFormElement.valid = this.checkValidity(updatedFormElement.value,
      updatedFormElement.validation);
    updatedFormElement.errorMessage = this.getErrorMessage(updatedFormElement.value,
      updatedFormElement.validation);

    updatedOrderForm[elementId] = updatedFormElement;

    this.setState({ managersForm: updatedOrderForm });
  }

  registerHandler = (event) => {
    event.preventDefault();
    this.setState({ loading: true });
    const registerDetails = {
      email: this.state.registerForm.email.value + "@ufc.dp.ua",
      password: this.state.registerForm.password.value,
      fname: this.state.registerForm.fname.value,
      lname: this.state.registerForm.lname.value,
    };

    axios.post('/api/v1/signup', registerDetails)
      .then(response => {
        console.log(response);
        if (response.data === null) {
          this.props.addNotification("Помилка, пошта повинна закінчуватися на `@ufc.dp.ua`.", "Danger");
        } else {
          this.props.addNotification("Ви успішно зареєструвалися в UFC Kanban. Щоб завершити процес реєстрації, перейдіть за посиланням, яке було надіслано вам на вказану поштову скриньку.", "Success");
          this.setState({ loading: false });
        }
      })
      .catch(error => {
        console.log(error);
        if (error.response) {
          this.props.addNotification("Помилка: " + error.response.data.error_description, "Danger");
          logError(
            this.props.access_token,
            error.response.data.error_description,
            '/api/v1/signup'
          );
        }
        this.setState({ loading: false });
      });
  }

  loginHandler = (event) => {
    event.preventDefault();
    this.setState({ loading: true });

    const loginDetails = {
      "grant_type": "password",
      "username": this.state.loginForm.email.value + "@ufc.dp.ua",
      "password": this.state.loginForm.password.value,
      "client_id": "spring-security-oauth2-read-write-client"
    };

    axios({
      method: 'get',
      url: '/api/v1/signup/enabled?email=' + this.state.loginForm.email.value + "@ufc.dp.ua",
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
      .then(response => {
        if (response.data === false) {
          this.props.addNotification("Вам потрібно підтвердити акаунт, щоб увійти.", "Danger");
          this.setState({ loading: false })
          return;
        }
        axios({
          method: 'post',
          url: '/oauth/token',
          data: qs.stringify(loginDetails),
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          auth: {
            username: "spring-security-oauth2-read-write-client",
            password: "spring-security-oauth2-read-write-client-password1234"
          }
        })
          .then(response => {
            this.props.addNotification("Ви успішно авторизувалися в системі.", "Success");
            localStorage.setItem("access_token", response.data.access_token);
            localStorage.setItem("refresh_token", response.data.refresh_token);
            localStorage.setItem("name", this.state.loginForm.email.value);
            this.props.onAuthenticated(response.data.access_token,
              response.data.refresh_token,
              this.state.loginForm.email.value);
            this.setState({ loading: false });
            console.log("Authenticated Successfully");
          })
          .catch(error => {
            console.log(error);
            if (error.response && error.response.data.error_description === "User account is locked") {
              this.props.addNotification("Помилка: Обліковий запис заблоковано. Зверніться до адміністратора сайту.", "Danger");
              logError(
                this.props.access_token,
                "Помилка: Обліковий запис заблоковано. Зверніться до адміністратора сайту.",
                '/oauth/token'
              );
            } else if (error.response) {
              logError(
                this.props.access_token,
                this.props.codeToMessage[error.response.status],
                '/oauth/token'
              );
              this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
            }

            if (localStorage.getItem("access_token")) {
              axios({
                method: 'post',
                url: '/api/v1/tokens/revoke/' + localStorage.getItem("access_token"),
                headers: { 'Authorization': 'Bearer ' + localStorage.getItem("access_token") },
              })
                .then(response => {
                  console.log(response);
                  localStorage.removeItem("access_token");
                  localStorage.removeItem("refresh_token");
                  this.props.onSetManagerName(null);
                  this.props.onLogout();
                })
                .catch(error => {
                  console.log(error);
                  localStorage.removeItem("access_token");
                  localStorage.removeItem("refresh_token");
                  this.props.onSetManagerName(null);
                  this.props.onLogout();
                });
            }
            this.setState({ loading: false });
          });
      })
      .catch(error => {
        console.log(error);
        if (error.response) {
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        }
      });
  }

  forgotPasswordHandler = (event) => {
    event.preventDefault();
    this.setState({ loading: true });

    axios.post('api/v1/signup/forgotPassword', { email: this.state.forgotPasswordForm.email.value + "@ufc.dp.ua" })
      .then(response => {
        console.log(response);
        this.setState({ loading: false });
        this.props.addNotification("Щоб створити новий пароль, перейдіть за посиланням, яке було надіслано вам на поштову скриньку.", "Success");
      })
      .catch(error => {
        console.log(error);
        this.setState({ loading: false });
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            'api/v1/signup/forgotPassword'
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        }
      });
  }

  resetPasswordHandler = (event) => {
    event.preventDefault();
    this.setState({ loading: true });

    if (this.state.resetPasswordForm.password.value === this.state.resetPasswordForm.passwordConfirm.value) {
      axios.post('api/v1/signup/resetPassword?token=' + this.state.resetPasswordToken,
        { password: this.state.resetPasswordForm.password.value })
        .then(response => {
          console.log(response);
          this.setState({ loading: false });
          this.props.addNotification("Пароль був успішно змінений. Тепер ви можете використовувати поштову скриньку та новий пароль, щоб увійти в систему.", "Success");
        })
        .catch(error => {
          console.log(error);
          this.setState({ loading: false });
          if (error.response) {
            this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
          }
        });
    }
  }

  saveLocations = (event) => {
    event.preventDefault();
    this.setState({ loading: true });
    const updatedLocations = [...this.state.locationForm.locations.value];
    updatedLocations.forEach(function (data) {
      data['locationName'] = data['location'];
      delete data['location'];
    });

    axios({
      method: 'post',
      data: updatedLocations,
      url: '/api/v1/locations/saveAll',
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        console.log(response);
        this.setState({ loading: false });
        this.props.addNotification("Локації були успішно збережені.", "Success");
        this.props.onSetLocations(response.data);
      })
      .catch(error => {
        console.log(error);
        this.setState({ loading: false });
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/locations/saveAll'
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        }
      });
  }

  updateUserRoles = (event) => {
    event.preventDefault();
    for (let i = 0; i < this.state.usersForm.users.value.length; i++) {
      let newUser = this.state.usersForm.users.value[i];
      let oldUser = this.state.initialUserRoles[i];
      if (oldUser.role !== newUser.role || oldUser.locked !== newUser.locked || oldUser.asteriskId !== newUser.asteriskId || oldUser.miniAsterisk !== newUser.miniAsterisk) {
        this.updateUser(newUser);
      }
    }

    const deepCopy = [];
    for (let i = 0; i < this.state.usersForm.users.value.length; i++) {
      deepCopy.push({ ...this.state.usersForm.users.value[i] });
    }
    this.setState({ initialUserRoles: deepCopy });
  }

  updateUser(user) {
    axios({
      method: 'post',
      data: { email: user.email, roleId: parseInt(user.role), locked: user.locked, asteriskId: user.asteriskId, miniAsterisk: user.miniAsterisk },
      url: '/api/v1/users/roles',
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        console.log(response);
        this.props.addNotification("Оновив користувача " + user.email + ".", "Success");
      })
      .catch(error => {
        console.log(error);
        this.setState({ loading: false });
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/users/roles'
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        }
      });
  }

  updateManagers = (ev) => {
    ev.preventDefault();
    const updatedManagers = this.state.managersForm.managers.value;
    axios({
      method: 'post',
      data: updatedManagers,
      url: '/api/v1/managers',
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        console.log(response);
        this.props.addNotification("Оновив менеджерів.", "Success");
      })
      .catch(error => {
        console.log(error);
        this.setState({ loading: false });
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/managers'
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        }
      });
  }

  render() {
    let backgroundStyle = {
      background: "linear-gradient(rgba(245, 179, 73, 0.2), rgba(245, 179, 73, 0.2)),url(" + ufcLogo + ")",
      backgroundRepeat: "repeat",
      backgroundSize: "200px"
    };

    let content = null;

    if (this.props.access_token === null) {
      if (this.state.resetPassword) {
        const resetPasswordFormArray = [];
        for (let key in this.state.resetPasswordForm) {
          resetPasswordFormArray.push({
            id: key,
            config: this.state.resetPasswordForm[key]
          });
        }
        content = (<div className={classes.Account} style={backgroundStyle}>

          <div className={classes.RegisterHolder}>
            <div className={classes.TitleHolder}>
              <h1>ОНОВИТИ ПАРОЛЬ</h1>
              {this.state.loading ? <Spinner margin="10px" /> : null}
            </div>
            <hr />
            <form className={classes.RegisterForm} onSubmit={this.resetPasswordHandler}>
              {resetPasswordFormArray.map(formElement => {
                return (
                  <Input
                    key={formElement.id}
                    label={formElement.config.label}
                    elementType={formElement.config.elementType}
                    elementConfig={formElement.config.elementConfig}
                    value={formElement.config.value}
                    invalid={!formElement.config.valid}
                    errorMessage={formElement.config.errorMessage}
                    extraAction={formElement.config.extraAction}
                    shouldValidate={formElement.config.validation && formElement.config.touched}
                    changed={(event) => this.resetPasswordInputChangedHandler(event, formElement.id)} />
                );
              })}

              <Button
                btnType='Success'
                disabled={!this.state.formIsValid || this.state.loading}
                iconAlt=''>ОНОВИТИ ПАРОЛЬ</Button>
            </form>

            <Button
              btnType='Danger'
              iconAlt=''
              clicked={() => this.setState({
                resetPassword: false,
                formIsValid: false,
                registered: false
              })}>ЛОГІН</Button>
          </div>
        </div>)
      } else if (this.state.forgotPassword) {
        const forgotPasswordFormArray = [];
        for (let key in this.state.forgotPasswordForm) {
          forgotPasswordFormArray.push({
            id: key,
            config: this.state.forgotPasswordForm[key]
          });
        }
        content = (<div className={classes.Account} style={backgroundStyle}>

          <div className={classes.RegisterHolder}>
            <div className={classes.TitleHolder}>
              <h1>ВІДНОВЛЕННЯ ПАРОЛЯ</h1>
              {this.state.loading ? <Spinner margin="10px" /> : null}
            </div>
            <hr />
            <form className={classes.RegisterForm} onSubmit={this.forgotPasswordHandler}>
              {forgotPasswordFormArray.map(formElement => {
                return (
                  <Input
                    key={formElement.id}
                    label={formElement.config.label}
                    elementType={formElement.config.elementType}
                    elementConfig={formElement.config.elementConfig}
                    value={formElement.config.value}
                    invalid={!formElement.config.valid}
                    errorMessage={formElement.config.errorMessage}
                    extraAction={formElement.config.extraAction}
                    shouldValidate={formElement.config.validation && formElement.config.touched}
                    changed={(event) => this.forgotPasswordInputChangedHandler(event, formElement.id)} />
                );
              })}

              <Button
                btnType='Success'
                disabled={!this.state.formIsValid || this.state.loading}
                iconAlt=''>ЗАБУВ ПАРОЛЬ</Button>
            </form>

            <Button
              btnType='Danger'
              iconAlt=''
              clicked={() => this.setState({
                forgotPassword: false,
                formIsValid: false
              })}>ЛОГІН</Button>
          </div>
        </div>)
      } else {
        if (this.state.registered) {
          const loginFormArray = [];
          for (let key in this.state.loginForm) {
            loginFormArray.push({
              id: key,
              config: this.state.loginForm[key]
            });
          }

          content = (
            <div className={classes.Account} style={backgroundStyle}>

              <div className={classes.RegisterHolder}>
                <div className={classes.TitleHolder}>
                  <h1>ЛОГІН</h1>
                  {this.state.loading ? <Spinner margin="10px" /> : null}
                </div>
                <hr />
                <form className={classes.RegisterForm} onSubmit={this.loginHandler}>
                  {loginFormArray.map(formElement => {
                    return (
                      <Input
                        key={formElement.id}
                        label={formElement.config.label}
                        elementType={formElement.config.elementType}
                        elementConfig={formElement.config.elementConfig}
                        value={formElement.config.value}
                        invalid={!formElement.config.valid}
                        errorMessage={formElement.config.errorMessage}
                        extraAction={formElement.config.extraAction}
                        shouldValidate={formElement.config.validation && formElement.config.touched}
                        changed={(event) => this.loginInputChangedHandler(event, formElement.id)} />
                    );
                  })}

                  <Button
                    btnType='Success'
                    disabled={!this.state.formIsValid || this.state.loading}
                    iconAlt=''>УВІЙТИ</Button>

                </form>

                <Button
                  btnType='Danger'
                  iconAlt=''
                  clicked={() => this.setState({
                    registered: false,
                    formIsValid: false
                  })}>
                  РЕЄСТРАЦІЯ
                </Button>

                <p
                  className={classes.ForgotPasswordLink}
                  onClick={() => this.setState({
                    forgotPassword: true,
                    formIsValid: false
                  })}>
                  Забув Пароль
                </p>
              </div>

            </div>
          );
        } else {
          const registerFormArray = [];
          for (let key in this.state.registerForm) {
            registerFormArray.push({
              id: key,
              config: this.state.registerForm[key]
            });
          }

          content = (
            <div className={classes.Account} style={backgroundStyle}>

              <div className={classes.RegisterHolder}>
                <div className={classes.TitleHolder}>
                  <h1>СТВОРИТИ АККАУНТ</h1>
                  {this.state.loading ? <Spinner margin="10px" /> : null}
                </div>
                <hr />
                <form className={classes.RegisterForm} onSubmit={this.registerHandler}>
                  {registerFormArray.map(formElement => {
                    return (
                      <Input
                        key={formElement.id}
                        label={formElement.config.label}
                        elementType={formElement.config.elementType}
                        elementConfig={formElement.config.elementConfig}
                        value={formElement.config.value}
                        invalid={!formElement.config.valid}
                        errorMessage={formElement.config.errorMessage}
                        extraAction={formElement.config.extraAction}
                        shouldValidate={formElement.config.validation && formElement.config.touched}
                        changed={(event) => this.inputChangedHandler(event, formElement.id)} />
                    );
                  })}

                  <Button
                    btnType='Success'
                    disabled={!this.state.formIsValid || this.state.loading}
                    iconAlt=''>ЗАРЕЄСТРУВАТИСЯ</Button>
                </form>

                <Button
                  btnType='Danger'
                  iconAlt=''
                  clicked={() => this.setState({ registered: true, formIsValid: false })}>ЛОГІН</Button>
              </div>

            </div>
          );
        }
      }
    } else {
      const editLocationsArray = [];
      for (let key in this.state.locationForm) {
        editLocationsArray.push({
          id: key,
          config: this.state.locationForm[key]
        });
      }

      const userRolesFormArray = [];
      for (let key in this.state.usersForm) {
        userRolesFormArray.push({
          id: key,
          config: this.state.usersForm[key]
        });
      }

      const managersFormArray = [];
      for (let key in this.state.managersForm) {
        managersFormArray.push({
          id: key,
          config: this.state.managersForm[key]
        });
      }

      let adminArea = null;
      if (this.props.role === "ROLE_ADMIN") {
        adminArea = (
          <Aux>
            <UserPreferencesModal
              manager={this.state.editManagerPreferences}
              close={(ev) => this.setState({ editManagerPreferences: null })}
              show={this.state.editManagerPreferences !== null} />
            <div className={classes.AdminArea}>

              <form className={classes.LocationForm} onSubmit={() => null}>
                {editLocationsArray.map(formElement => {
                  return (
                    <Input
                      key={formElement.id}
                      label={formElement.config.label}
                      elementType={formElement.config.elementType}
                      elementConfig={formElement.config.elementConfig}
                      value={formElement.config.value}
                      invalid={!formElement.config.valid}
                      errorMessage={formElement.config.errorMessage}
                      extraAction={formElement.config.extraAction}
                      shouldValidate={formElement.config.validation && formElement.config.touched}
                      changed={(event) => this.locationChangedHandler(event, formElement.id)} />
                  );
                })}

                <Button
                  btnType='Success'
                  clicked={this.saveLocations}
                  disabled={!this.state.formIsValid || this.state.loading}
                  iconAlt=''>ЗБЕРЕГТИ</Button>
              </form>

              <form className={classes.UserRolesForm} onSubmit={() => null}>
                {userRolesFormArray.map(formElement => {
                  return (
                    <Input
                      key={formElement.id}
                      label={formElement.config.label}
                      elementType={formElement.config.elementType}
                      elementConfig={formElement.config.elementConfig}
                      value={formElement.config.value}
                      invalid={!formElement.config.valid}
                      errorMessage={formElement.config.errorMessage}
                      extraAction={formElement.config.extraAction}
                      shouldValidate={formElement.config.validation && formElement.config.touched}
                      changed={(event) => this.usersChangedHandler(event, formElement.id)} />
                  );
                })}

                <Button
                  btnType='Success'
                  clicked={this.updateUserRoles}
                  disabled={this.state.loading}
                  iconAlt=''>ЗБЕРЕГТИ</Button>
              </form>

              <form className={classes.ManagersForm} onSubmit={() => null}>
                {managersFormArray.map(formElement => {
                  return (
                    <Input
                      key={formElement.id}
                      label={formElement.config.label}
                      elementType={formElement.config.elementType}
                      elementConfig={formElement.config.elementConfig}
                      value={formElement.config.value}
                      invalid={!formElement.config.valid}
                      errorMessage={formElement.config.errorMessage}
                      extraAction={formElement.config.extraAction}
                      shouldValidate={formElement.config.validation && formElement.config.touched}
                      changed={(event) => this.managersChangedHandler(event, formElement.id)} />
                  );
                })}

                <Button
                  btnType='Success'
                  clicked={this.updateManagers}
                  disabled={this.state.loading}
                  iconAlt=''>ЗБЕРЕГТИ</Button>
              </form>
            </div>
          </Aux>
        );
      }

      content = (
        <div className={classes.AccountHolder}>
          <div className={classes.MyAccount}>
            <h1>Мій Акаунт</h1>
            <hr />
            <div>Увійшов у систему як <strong>{this.props.name}</strong></div>
          </div>
          {adminArea}
        </div>
      );
    }

    return (
      <Aux>
        {content}
      </Aux>
    );
  }
}

const mapStateToProps = state => {
  return {
    authenticated: state.authenticated,
    access_token: state.access_token,
    name: state.name,
    notifications: state.notifications,
    carriers: state.carriers,
    managers: state.managers,
    locations: state.locations,
    role: state.role,
    codeToMessage: state.codeToMessage
  };
}

const mapDispatchToProps = dispatch => {
  return {
    onAuthenticated: (tokenValue, refreshValue, name) => dispatch({
      type: actionTypes.LOGIN,
      access_token: tokenValue,
      refresh_token: refreshValue,
      name: name
    }),
    onLogout: () => dispatch({ type: actionTypes.LOGOUT }),
    addNotification: (notification, notificationType) => dispatch({
      type: actionTypes.ADD_NOTIFICATION,
      notification: notification,
      notificationType: notificationType
    }),
    onSetCarriers: (carriers) => dispatch({
      type: actionTypes.SET_CARRIERS,
      carriers: carriers
    }),
    onSetManagers: (managers) => dispatch({
      type: actionTypes.SET_MANAGERS,
      managers: managers
    }),
    onSetLocations: (locations) => dispatch({
      type: actionTypes.SET_LOCATIONS,
      locations: locations
    })
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Account);



// WEBPACK FOOTER //
// ./src/containers/Account/Account.js